import { render } from "./EditTaxAddressModal.vue?vue&type=template&id=51376f75&scoped=true"
import script from "./EditTaxAddressModal.vue?vue&type=script&lang=js"
export * from "./EditTaxAddressModal.vue?vue&type=script&lang=js"

import "./EditTaxAddressModal.vue?vue&type=style&index=0&id=51376f75&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51376f75"]])

export default __exports__